/* eslint-disable */

import { ViewportProvider } from '@cleartax/wg-library-hooks';
import { Toast } from '@cleartax/wg-library-toast';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useEffect } from 'react';
import { Page } from '../../page';
import { MP_GTM_ID, REDIRECTION_OVERLAY_ID } from '../config/constants';
import {
  RAZORPAY_SDK_FOR_PHONEPE_SRC,
  RAZORPAY_SDK_SRC
} from '../hooks/useRazorpay/configs';
import { ErrorBoundary } from '../shared/components/ui-blocks/error-boundary/index';
import { UserContainer } from '../shared/context/user/container';

import {
  B2C_GA4_TRACKING_ID,
  CATEGORY_MARKETPLACE_WEBSITE,
  EVENTS,
  GA4_TRACKING_ID
} from '../shared/utils/tracker/configs';
import {
  getUTMParameters,
  pageview,
  setUTMParamInCookie,
  trackActionGA4
} from '../shared/utils/tracker/utils';
import '../styles/globals.css';
interface IPageProps {
  username: string;
  isLoggedIn: boolean;
}

type Props = AppProps & {
  Component: Page;
};
function MyApp({ Component, pageProps }: Props) {
  const router = useRouter();
  const getLayout = Component.getLayout ?? ((page) => page);
  useEffect(() => {
    if (window !== undefined) setUTMParamInCookie(window.location.search);
    trackActionGA4(EVENTS.pageView, {
      label: window.location.pathname,
      parent_category: CATEGORY_MARKETPLACE_WEBSITE,
      content_group: CATEGORY_MARKETPLACE_WEBSITE + '_' + '',
      current_page_pathname: window.location.pathname,
      ...getUTMParameters(),
    });
    const handleRouteChange = (url: string) => {
      pageview(url, GA4_TRACKING_ID);
      pageview(url, B2C_GA4_TRACKING_ID);
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, []);

  useEffect(() => {
    if (window && document && !window.Razorpay) {
      const script = document.createElement('script');
      const head = document.getElementsByTagName('head')[0];
      if (navigator.userAgent.includes('phonepe-webview')) {
        script.type = 'text/javascript';
        script.src = RAZORPAY_SDK_FOR_PHONEPE_SRC;
      } else {
        script.src = RAZORPAY_SDK_SRC;
      }
      head.appendChild(script);
    }
  });
  return (
    <ErrorBoundary>
      <ViewportProvider>
          <UserContainer
            username={pageProps.username}
            isLoggenIn={pageProps.isLoggedIn}
            role={pageProps.role}
          >
            <Toast />
            <Head>
              <script
                dangerouslySetInnerHTML={{
                  __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${MP_GTM_ID}')`,
                }}
              ></script>
            </Head>
            <noscript>
              <iframe
                src={`https://www.googletagmanager.com/ns.html?id=${MP_GTM_ID}`}
                height="0"
                width="0"
                style={{
                  display: 'none',
                  visibility: 'hidden',
                }}
              ></iframe>
            </noscript>
            {getLayout(<Component {...pageProps} />)}

            <div id={REDIRECTION_OVERLAY_ID}></div>
            <Script
              strategy="afterInteractive"
              src={`https://www.googletagmanager.com/gtag/js?id=${GA4_TRACKING_ID}`}
            />
            <Script
              strategy="afterInteractive"
              src={`https://www.googletagmanager.com/gtag/js?id=${B2C_GA4_TRACKING_ID}`}
            />
            <Script
              id="gtag-init"
              strategy="afterInteractive"
              dangerouslySetInnerHTML={{
                __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${GA4_TRACKING_ID}', {
                page_path: window.location.pathname,
              });
              gtag('config', '${B2C_GA4_TRACKING_ID}', {
                page_path: window.location.pathname,
              });
            `,
              }}
            />
          </UserContainer>
      </ViewportProvider>
    </ErrorBoundary>
  );
}

export default MyApp;
